/** File picker `accept` attribute for SOP sheet import (images + PDF). */
export const SOP_SHEET_FILE_ACCEPT = 'image/*,application/pdf';

const MAX_SHEET_DATA_URI_CHARS = 14 * 1024 * 1024;

const PDF_MIME_TYPES = new Set(['application/pdf', 'application/x-pdf']);

function hasPdfExtension(fileName: string): boolean {
  return fileName.toLowerCase().endsWith('.pdf');
}

export function isAcceptedSopSheetFile(file: File): boolean {
  if (PDF_MIME_TYPES.has(file.type) || (file.type === '' && hasPdfExtension(file.name))) {
    return true;
  }
  if (hasPdfExtension(file.name)) return true;
  return file.type.startsWith('image/');
}

export function assertSopSheetDataUriSize(dataUri: string): void {
  if (dataUri.length > MAX_SHEET_DATA_URI_CHARS) {
    throw new Error('SHEET_TOO_LARGE');
  }
}

export const SOP_SHEET_MAX_DATA_URI_CHARS = MAX_SHEET_DATA_URI_CHARS;

const DATA_URI_RE = /^data:([^;]+);base64,(.+)$/;

const ALLOWED_MIME_RE = /^(image\/[a-zA-Z0-9.+-]+|application\/pdf|application\/x-pdf)$/;

/**
 * Parse a data URI from an uploaded SOP sheet image or PDF for Gemini inline data.
 */
export function parseSopSheetDataUri(dataUri: string): { mimeType: string; base64Data: string } {
  const matches = dataUri.match(DATA_URI_RE);
  if (!matches || matches.length !== 3) {
    throw new Error('Invalid sheet data URI format (expected data:<mime>;base64,<data>)');
  }

  let mimeType = matches[1];
  const base64Data = matches[2];

  if (mimeType === 'application/x-pdf') {
    mimeType = 'application/pdf';
  }

  if (!ALLOWED_MIME_RE.test(mimeType)) {
    throw new Error('Unsupported file type. Use an image (PNG, JPEG, etc.) or PDF.');
  }

  return { mimeType, base64Data };
}
